import { EnvironmentProviders, Provider } from '@angular/core';
import { QAREPA_API_BASE_URL } from '@qarepa/common';
import { ApiQBonoEnv } from '@qaroni-merchant-core/config/apis/api-qbono/api-qbono.config';

export const provideApiBaseUrl = (): (Provider | EnvironmentProviders)[] => {
  return [{ provide: QAREPA_API_BASE_URL, useValue: ApiQBonoEnv.baseUrl }];
};
